// extracted by mini-css-extract-plugin
export default {"link":"AboutMe_link__his4j"};